module.exports = __webpack_public_path__ + "img/resume_tx.add1af6c.png";